import * as T from './actionTypes';

/**
 * Fetch the cumulative maintenance cost for an asset.
 *
 * @param {object} params { assetId, from, to, includeChildren }
 *   from/to are ISO date strings (YYYY-MM-DD) or null for "no bound".
 */
export const fetchAssetCost = (params) => ({ type: T.FETCH_ASSET_COST, payload: params });
export const fetchAssetCostSuccess = (cost) => ({ type: T.FETCH_ASSET_COST_SUCCESS, payload: cost });
export const fetchAssetCostFail = (error) => ({ type: T.FETCH_ASSET_COST_FAIL, payload: error });
export const clearAssetCost = () => ({ type: T.CLEAR_ASSET_COST });
